import { Button, notification } from 'antd';
import moment from 'moment';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CURRENT_HASH, VERSION_UPDATE_DATE } from '../../shared/constants/commonConstants';
import { RootState } from '../../store';
import { checkHash, newVersionAvilable } from '../../store/actions/utilAction';
import { getDateWithTextMonth } from '../dateTimeUtils';

const AppVersionChangeNotifier = (): ReactElement => {
  const [versionUpdatedDate, setVersionUpdatedDate] = useState('');
  const isNewVersion = useSelector(
    (state: RootState): any => state.util.isNewVersionAvilable,
  );
  useEffect((): void | (() => void | undefined) => {
    window.addEventListener('load', versionAlert);
    return (): void => {
      window.removeEventListener('load', versionAlert);
    };
  }, []);

  const versionAlert = (): void => {
    const versionDate = localStorage.getItem(VERSION_UPDATE_DATE) || '';
    const formattedDate = getDateWithTextMonth(versionDate);
    if (formattedDate !== 'Invalid date') {
      setVersionUpdatedDate(formattedDate);
    }
  };
  const NewVersionNotificationArguments = {
    key: 'newVersion',
    message: 'Version update',
    description: moment().isSameOrAfter(moment('2021-07-01')) &&
      versionUpdatedDate ? `New version of IHX is available. Kindly refresh the page to update.\n
      Release Date: ${versionUpdatedDate || 'NA'}` : '',
    duration: 0,
  };

  const dispatch = useDispatch();
  const reloadClickHandler = (): any => {
    dispatch(newVersionAvilable(false));
    localStorage.removeItem(CURRENT_HASH);
    window.location.reload();
  };

  const btn = (
    <Button type="primary" size="small" onClick={reloadClickHandler}>
      Refresh
    </Button>
  );
  const handleHashCheckInterval = (): any => {
    let interval: any;
    if (process.env.NODE_ENV !== 'development') {
      interval = setInterval((): any => {
        dispatch(checkHash());
      }, Number(process.env.REACT_APP_VERSION_CHECK_INTERVAL));
      dispatch(checkHash());
      return (): void => clearInterval(interval);
    } else {
      return (): void => {};
    }
  };

  useEffect((): any => {
    handleHashCheckInterval();
  }, []);

  const openNotification = (): void => {
    notification.info({ ...NewVersionNotificationArguments, btn, onClose });
  };

  const onClose = (): void => {
     dispatch(newVersionAvilable(false));
  };

  return (
    <>
      {isNewVersion && openNotification()}
    </>
  );
};

export default AppVersionChangeNotifier;
